import Constant from '@/common/constant/Constant';
import { submitAcceptAnonymousQaTicket } from '@/component/chatThread/handler/DetailTicketHandler';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { onSubmitAcceptAnonymousQaTicket } from '../handler/TicketListHandler';

export const DialogConfirmAcceptAnonymousQaTicket = (props) => {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const isOpen = props.isConfirmAcceptTicket;

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        props.setIsConfirmAcceptTicket(false);
    };

    const onSubmitEditTicket = () => {
        if (props.parentPanelScreen === Constant.PANEL_TYPE.HELPDESK_TICKET_LIST) {
            onSubmitAcceptAnonymousQaTicket(props);
        } else if (props.parentPanelScreen === Constant.PANEL_TYPE.DETAIL_TICKET) {
            submitAcceptAnonymousQaTicket(props);
        }
        props.setIsConfirmAcceptTicket(false);
    }

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {trI18n('USER04MSG026')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                    onClick={onSubmitEditTicket}
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
